import * as types from '../actions/auditLog/types';


const INITIAL_STATE = {
  actions: [],
  searchResults: [],
};

export default function auditLogReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.GET_AUDIT_ACTIONS:

      return {
        ...state,
        actions: action.payload,
      };

    case types.GET_AUDIT_LOG:

      return {
        ...state,
        searchResults: action.payload,
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/auditLogReducer.js